import type { BaseDataItem } from '@wix/thunderbolt-becky-types'
import type { VsmContext, MasterPageConfigEntry, MasterPageConfigFn } from '@wix/thunderbolt-vsm-api'
import type { TranslationMasterPageConfig } from '../types'
import { name } from '../symbols'

function buildPageIdToPageUriSEOFromTranslation(
	masterPageTranslations:
		| Record<
				string,
				{
					data?: { document_data?: Record<string, BaseDataItem & { type?: string; pageUriSEO?: string; id?: string }> }
				}
		  >
		| undefined
): Record<string, Record<string, string>> {
	const result: Record<string, Record<string, string>> = {}
	if (!masterPageTranslations) return result
	for (const [lang, languageData] of Object.entries(masterPageTranslations)) {
		const documentData = languageData?.data?.document_data
		if (!documentData) {
			result[lang] = {}
			continue
		}
		const pageIdToUri: Record<string, string> = {}
		for (const item of Object.values(documentData)) {
			if ((item.type === 'Page' || item.type === 'AppPage') && item.pageUriSEO != null && item.id != null) {
				pageIdToUri[item.id] = item.pageUriSEO
			}
		}
		result[lang] = pageIdToUri
	}
	return result
}

const translationsMasterPageConfig: MasterPageConfigFn<TranslationMasterPageConfig> = ({
	api,
	funcLib,
}: VsmContext) => {
	const masterPageTranslations = api.env.get<Record<string, { data?: { document_data?: Record<string, unknown> } }>>(
		'masterPageTranslations'
	)

	const pagesMap = api.page.getPagesMap()
	const pageIdToPageUriSEO: Record<string, string> = {}
	for (const [pageUriSEO, entry] of Object.entries(pagesMap)) {
		if (entry?.id) {
			pageIdToPageUriSEO[entry.id] = pageUriSEO
		}
	}

	const pageIdToPageUriSEOFromTranslation = buildPageIdToPageUriSEOFromTranslation(
		masterPageTranslations as Parameters<typeof buildPageIdToPageUriSEOFromTranslation>[0]
	)

	const isPageUriSEOTranslated =
		funcLib?.isPageUriSEOTranslated?.(pageIdToPageUriSEO, pageIdToPageUriSEOFromTranslation) ?? false

	const originalLanguage = api.env.getOriginalLanguage()
	const hasOriginalLanguageTranslation = originalLanguage
		? Object.prototype.hasOwnProperty.call(masterPageTranslations ?? {}, originalLanguage)
		: false

	return {
		isPageUriSEOTranslated,
		hasOriginalLanguageTranslation,
	}
}

export const masterPageConfig: MasterPageConfigEntry<TranslationMasterPageConfig> = {
	name,
	configFactory: translationsMasterPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
